const CSElectricProofJSMethodObject = window.CSElectricProofJSMethodObject

export { CSElectricProofJSMethodObject }